import React from 'react'
// icons
import BlockIcon from '@mui/icons-material/Block'
// themes
import { colors } from 'themes/index'
// components
import LogOut from 'layouts/MainLayout/UserBlock/LogOut'
// views
import { WarningMessage, WarningWrapper } from './views'

const AuthWarning: React.FC = () => {
  return (
    <WarningWrapper>
      <BlockIcon sx={{ fontSize: 200, marginBottom: 2, color: colors.purple300 }} />
      <WarningMessage>
        You are not authorised to view any pages.
        <br />
        Please contact your system administrator to request permission.
        <LogOut isButton />
      </WarningMessage>
    </WarningWrapper>
  )
}

export default AuthWarning
